<template>
  <div>
    <div class="chat-container">
      <div v-for="(msg, index) in messages" :key="index" v-html="mdToHtml(msg)"></div>
    </div>
  </div>


</template>

<script>
import VConsole from 'vconsole'

new VConsole()
import ajax from '../api/ajax';
import marked from 'marked';
import DOMPurify from 'dompurify';

export default {
  name: "CaseView",
  data() {
    return {
      content: '',
      messages: [],
      collectionId: ""

    };
  },
  mounted() {
    this.dataId = this.$route.query.dataId
    this.citeId = this.$route.query.citeId
    this.chatId = this.$route.query.chatId
    this.collectionId = this.$route.query.collectionId
    this.chatType = this.$route.query.chatType
    document.title = `AI营养处方助手`;
    this.getQuota()
  },

  methods: {
    getQuota() {
      ajax
          .Post({
            url: '/api/ai/hlxj/chat/fastgpt/selectQuotaTxtById',
            data: {
              chatId: this.chatId || "15132452294",
              dataId: this.dataId,
              id: this.citeId,
              initialId: this.citeId,
              collectionId: this.collectionId,
              initialIndex: 0,
              chatType: this.chatType
            }
          }).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.list && Array.isArray(res.data.data.list)) {
            const markdownComponents = res.data.data.list.map((item) => {
              if (item.q) {
                // 直接将 item.q 作为 Markdown 字符串返回
                return item.q;
              }
              return null;
            }).filter(Boolean); // 过滤掉null值
            // 将处理后的 Markdown 字符串数组赋值给 this.messages
            this.messages = markdownComponents;
          }

        } else {
          console.log("失败")
        }
      })
    },
    getMsg(msg) {
      // 如果 msg 是字符串，直接返回
      if (typeof msg === 'string') {
        return msg;
      }
      // 如果是对象，按原来的逻辑处理
      const textObj = msg?.value?.find(v => v.type === "text");
      return textObj?.text?.content || "";
    },
    // Markdown -> 安全 HTML
    mdToHtml(markdown) {
      const renderer = new marked.Renderer();

      // 自定义 link 渲染
      renderer.link = (href, title, text) => {
        if (/^\w+$/.test(href)) {
          // 返回自定义 span 标签，不用 onclick
          return `<span style="color: deepskyblue" class="cite-tag" > “” </span>`;
        } else {
          return `<a href="${text}" target="_blank">${text}</a>`;
        }
      };

      const rawHtml = marked.parse(markdown, {renderer});
      // 保留 data-cite 属性
      return DOMPurify.sanitize(rawHtml, {ADD_ATTR: ['data-cite']});
    },
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}


.chat-container {
  height: 100vh;
  overflow: auto;
  background-color: #fff;
  padding: 15px;
}


</style>
